// Ancho real de un contenedor: las graficas dibujan con ese ancho para que el texto de los ejes no crezca
// al ampliar un recuadro ni se encoja en el celular.
import { useCallback, useEffect, useRef, useState } from 'react';

export function useAncho(porDefecto = 640): [(el: HTMLElement | null) => void, number] {
  const [ancho, setAncho] = useState(porDefecto);
  const ro = useRef<ResizeObserver | null>(null);
  const ref = useCallback((el: HTMLElement | null) => {
    ro.current?.disconnect();
    if (!el || typeof ResizeObserver === 'undefined') return;
    ro.current = new ResizeObserver(([e]) => {
      const w = Math.round(e.contentRect.width);
      if (w > 0) setAncho((x) => (Math.abs(x - w) > 2 ? w : x));
    });
    ro.current.observe(el);
  }, []);
  useEffect(() => () => ro.current?.disconnect(), []);
  return [ref, Math.max(280, ancho)];
}
